<template>
  <div>
    <HeaderCreditor header="รายละเอียดการชำระเงิน " :img_header="header_image" link_back="creditor/transferfromdebtor"/>
    <Transfer_debtor_detail/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/money_creditor.png";
import Transfer_debtor_detail from "@/components/admin/creditor/Transfer_debtor_detail";
export default {
  name: "TransferDebtorDetail",
  components: {
    Transfer_debtor_detail,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
